<template>
  <div class="lv-state-ques-option-list">
    <div v-if="list && list.length">
      <LvStateQuesOption
        v-for="(option, optionIndex) in list"
        :key="optionIndex"
        :risk="option.risk"
        :title="option.title"
        :score="option.score"
        :hasSubOption="option.hasSubOption"
        :subOptionList="option.subOptionList"
        :requiredRemark="option.requiredRemark"
        class="lv-state-ques-option-list__option"
        @delete="$emit('delete', {...$event, optionIndex})"
        @add="$emit('add', optionIndex)"
        @input="$_onUpdateOption($event, optionIndex)"
      />
    </div>
    <LvFlexBox v-else noWrap alignItems="start" class="mb-8">
      <LvText h3 red><i class="icon-info" /></LvText>
      <LvText h6 red class="ml-6">{{ $t('必須至少設定2個選項！') }}</LvText>
    </LvFlexBox>
    <WsTextButton001
      small
      primary
      noPadding
      leadingIcon="icon-bih-add-circle"
      @click="$emit('add')"
    >{{ $t('新增') }}</WsTextButton001>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    }
  },
  methods: {
    $_onUpdateOption($event, index) {
      const {value, type, subOptionIndex} = $event;
      if (subOptionIndex === undefined) {
        const option = {
          ...this.list[index],
          [type]: value,
        };
        this.$emit('input', {value: option, index})
      } else {
        const subOption = {
          ...this.list[index].subOptionList[subOptionIndex],
          [type]: value,
        };
        this.$emit('input', {value: subOption, index, subOptionIndex})
      }
    },
  }
}
</script>